import axios from 'axios'
import Qs from 'qs'
import { parse, stringify } from 'qs'

import {
	clientStorageLocal,
	LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY,
} from '@ao/utils'

const getHref = () => {
	return window?.location.href || null
}

/**
 * @param {object} options - axios options
 * @param {string} options.url - endpoint
 * @param {string} [options.method=GET] - default - GET
 * @param {object} [options.params] - params
 * @param {object} [options.body] - body
 * @param {object} [options.headers] - body
 * @returns {Promise} Promise object
 */
export function request(options) {
	const token = clientStorageLocal.get(LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY)

	const href = getHref()

	let axiosConfig = {
		method: 'GET',
		url: '',
		params: {},
		body: null,
		headers: {
			'Content-Type': 'application/json'
			// 'Content-Language': i18n.locale, //TODO: добавлять ключ локали в запрос
		},
		...options,
	}

	if (href) {
		axiosConfig.headers['X-Custom-Referer'] = href
	}

	if (token && token !== 'undefined') axiosConfig.headers['Authorization'] = `Bearer ${token}`

	return new Promise((resolve, reject) => {
		axios({
			method: axiosConfig.method,
			url: axiosConfig.url,
			params: axiosConfig.params,
			paramsSerializer: function (params) {
				return Qs.stringify(params, {arrayFormat: 'comma'})
			},
			headers: axiosConfig.headers,
			data: axiosConfig.body,
		})
			.then((res) => {
				resolve(res.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
}
